import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import ManualDevicePaymentForm from "../inventory/Devices/Contract/ManualDevicePaymentForm";

const actions = { closeModal };

const manualDevicePaymentModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Manual Device Payment" onClose={closeModal}>
      <ManualDevicePaymentForm />
    </Modal>
  );
};

export default connect(null, actions)(manualDevicePaymentModal);
